module.exports = __webpack_public_path__ + "img/property-image-placeholder.a6427ff6.svg";